import { Container, TitleContainer } from '@/style-guide'
import {
  ProfilePicture,
  UserInfo,
  SendMessage,
  OrganizationProfilePicture,
} from '@/components'
import { Link } from 'react-router-dom'
export const AttendeeInfo = ({
  user,
  showMessage,
  guestCount,
  imageSize,
  showSocialIcons,
}) => {
  return (
    user && (
      <Container>
        <div style={{ display: 'flex', gap: '15px' }}>
          <ProfilePicture user={user} size={imageSize || 60} />
          <div>
            <UserInfo user={user} showSocialIcons={showSocialIcons} />
            {showMessage && <SendMessage user={user} size="small" />}
          </div>
        </div>
        {guestCount && (
          <div className="count-number-span">+{(guestCount || 0) - 1}</div>
        )}
      </Container>
    )
  )
}
export const HostInfo = ({
  user,
  showMessage = false,
  imageSize = 60,
  showLogin,
}) => {
  return user?._id ? (
    <Container>
      <TitleContainer>
        <ProfilePicture user={user} size={imageSize || 60} />
        <div style={{ marginLeft: '15px' }}>
          <div>
            Hosted by{' '}
            <Link to={`/profile/${user?.username}`} target="_blank">
              <b>
                {user.firstName || ''} {user.lastName || ''}
              </b>
            </Link>
          </div>
          {showMessage && (
            <div>
              <SendMessage
                size="small"
                user={user}
                showLogin={showLogin}
                isHostMessage={true}
                showButton={true}
                labelText="Message host"
              />
            </div>
          )}
        </div>
      </TitleContainer>
    </Container>
  ) : (
    ''
  )
}

export const OrganizationInfo = ({
  user,
  organization,
  showMessage = false,
  imageSize = 60,
  showLogin,
}) => {
  return user?._id ? (
    <Container>
      <TitleContainer>
        <OrganizationProfilePicture
          organization={organization}
          size={imageSize || 60}
        />
        <div style={{ marginLeft: '15px' }}>
          <div>
            Hosted by{' '}
            <Link
              to={`/dashboard/organizations/${organization?._id}`}
              target="_blank"
            >
              <b>{organization?.name}</b>
            </Link>
          </div>
          {showMessage && (
            <div>
              <SendMessage
                size="small"
                user={user}
                showLogin={showLogin}
                isHostMessage={true}
                showButton={true}
                labelText="Message host"
              />
            </div>
          )}
        </div>
      </TitleContainer>
    </Container>
  ) : (
    ''
  )
}
